import { render, staticRenderFns } from "./MLoaderDialog.vue?vue&type=template&id=35795e60&"
import script from "./MLoaderDialog.vue?vue&type=script&lang=js&"
export * from "./MLoaderDialog.vue?vue&type=script&lang=js&"
import style0 from "./MLoaderDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDialog,VProgressCircular})
